import auth from '@/middleware/auth'
import extensionConfigurationRoutes from './extensionConfigurationRoutes';
import analyticsRoutes from './analyticsRoutes';
import adminControlRoutes from './adminControlRoutes';

const authRoutes = [
    {
        path: "/",
        name: "index",
        redirect: "main",
        meta: {
            middleware: [auth],
            requiresAuth: true, // Triggers route protection on landing root
        },
    },
    {
        path: "/main",
        name: "main",
        component: () => import("@/views/Main.vue"),
        meta: {
            middleware: [auth],
            requiresAuth: true, // Protects the main layout and ensures children inherit verification
        },
        redirect: { name: "dashboard_validation" }, // FIX: Targets the exact Child Name to avoid path routing drops
        children: [
            {
                path: "/dashboard-validation",
                name: "dashboard_validation",
                component: () => import("@/views/Pages/DashboardValidation.vue"),
            },
            {
                path: "/dashboard",
                name: "dashboard",
                component: () => import("@/views/Pages/Dashboard.vue"),
            },
            // Extension configuration child routes
            ...extensionConfigurationRoutes,
            // Analytics child routes
            ...analyticsRoutes,
            // Admin Control child routes
            ...adminControlRoutes,
        ],
    },
];

export default authRoutes;